import React, { ReactNode } from "react";

import Button, { ButtonProps } from "../../../../../shared/components/design-system/Button";
import ButtonSet from "../../../../../shared/components/design-system/component-groups/ButtonSet";
import styles from "./NotificationAlert.module.scss";

export default function NotificationAlert({
  title,
  icon,
  iconAlt,
  actions,
  children,
}: {
  title: string;
  icon?: string;
  iconAlt?: string;
  actions?: ButtonProps[];
  children?: ReactNode | undefined;
}) {
  return (
    <div className={styles.NotificationAlert}>
      <div className={styles.ImageArea}>
        {icon ? <img className={styles.Image} src={icon} alt={iconAlt} width={179} height={81} /> : null}
      </div>
      <div className={styles.ActionsArea}>
        <div className={styles.Text}>
          <h2 className={styles.Title}>{title}</h2>
          {children}
        </div>
        {actions ? (
          <ButtonSet align="end" className={styles.Actions}>
            {actions.map((action, i) => (
              <Button key={i} {...action} size="small" />
            ))}
          </ButtonSet>
        ) : null}
      </div>
    </div>
  );
}
